import React, { useEffect, useState } from "react";
import { api, fmtEur, fmtInt } from "@/lib/api";
import { PageHeader, Section, EmptyState, Pill } from "@/components/ui-kit";
import { PackageOpen } from "lucide-react";

export default function Consignment() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState({});

  useEffect(() => {
    api.get("/stock/consignment").then(({ data }) => setRows(data));
  }, []);

  const filled = rows.filter(r => r.total_qty > 0);

  return (
    <div data-testid="consignment-page">
      <PageHeader
        title="Stock en Depósito"
        subtitle="Unidades físicamente fuera del almacén propio pero no vendidas. Vuelven a ti si no se liquidan."
      />

      {filled.length === 0 ? (
        <Section>
          <EmptyState
            title="No hay stock en depósito"
            description="Crea almacenes de tipo 'distribuidor' o 'depósito_cliente' y registra un movimiento 'envío a depósito'."
            testid="consignment-empty"
          />
        </Section>
      ) : (
        <div className="space-y-5" data-testid="consignment-list">
          {filled.map(w => (
            <Section key={w.warehouse_id} title={w.warehouse_name} description={
              <span>{w.type === "distribuidor" ? "Distribuidor" : "Depósito en cliente"} · {fmtInt(w.total_qty)} uds · valor PVP {fmtEur(w.total_value)}</span>
            }
              actions={<Pill tone={w.type === "distribuidor" ? "brand" : "warning"}>{w.type}</Pill>}
            >
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-[11px] uppercase tracking-[0.1em] text-ink2 bg-sidebar/40">
                      <th className="text-left px-5 py-3 font-medium">ISBN</th>
                      <th className="text-left px-5 py-3 font-medium">Título</th>
                      <th className="text-right px-5 py-3 font-medium">PVP</th>
                      <th className="text-right px-5 py-3 font-medium">Unidades</th>
                      <th className="text-right px-5 py-3 font-medium">Valor PVP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {w.items.map(it => (
                      <tr key={it.book_id} className="border-t border-line">
                        <td className="px-5 py-3 font-mono text-xs text-ink2">{it.isbn}</td>
                        <td className="px-5 py-3">{it.title}</td>
                        <td className="px-5 py-3 text-right font-mono">{fmtEur(it.pvp)}</td>
                        <td className="px-5 py-3 text-right font-mono">{fmtInt(it.qty)}</td>
                        <td className="px-5 py-3 text-right font-mono">{fmtEur(it.qty * it.pvp)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Section>
          ))}
        </div>
      )}
    </div>
  );
}
